import { Injectable } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingPageScreenService {
  private _loadingPage = new Subject<boolean>();
  public loadingPage$ = this._loadingPage.asObservable();
  private timer: any;
  private loadingtime: number = 1500;
  public shouldSkipLoading: boolean;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(event => {
        console.log('NavigationStart', event);
        this.clearTimer();
        this.startLoading();
      });

    this.router.events
      .pipe(
        filter(
          event =>
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        )
      )
      .subscribe(() => {
        this.stopLoading();
      });
  }

  startLoading() {
    console.log('startLoading');
    if (this.shouldSkipLoading) {
      this.shouldSkipLoading = false;
      return;
    }
    this.timer = setTimeout(() => {
      this._loadingPage.next(true);
    }, this.loadingtime);
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  stopLoading() {
    this.clearTimer();
    this._loadingPage.next(false);
  }
}
